import { createContext, useEffect, useState } from 'react';

const CommunityQuestionsProgressContext = createContext();

export function CommunityQuestionsProgressContextProvider(props) {

  const [currentPage, setCurrentPage] = useState(28);
  const [currentQ, setCurrentQ] = useState(0);


  function updateCurrentPageHandler(page) {
    setCurrentPage(page);
  }

  const context = {
    currentPage: currentPage,
    currentQ: currentQ,
    updateCurrentPage: updateCurrentPageHandler,
  };

  return <CommunityQuestionsProgressContext.Provider value={context}>
    {props.children}
  </CommunityQuestionsProgressContext.Provider>
}

export default CommunityQuestionsProgressContext;
